module.exports = __webpack_public_path__ + "assets/img/plan2-3.d430cc90.png";